import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '',
    routes: [
      {
        name: 'laichikok888',
        path: '/ics/property/laichikok888',
        component: () => import('./laichikok888'),
        props: { ics: 'c' },
      },
      {
        name: 'laichikok888_test',
        path: '/ics/property/test888',
        component: () => import('./test888'),
        props: { ics: 'c' },
      },
      {
        name: 'laichikok888_c',
        path: '/ics/property/commercial/laichikok888',
        component: () => import('./laichikok888'),
        props: { ics: 'c' },
      },
      {
        name: 'laichikok888_i',
        path: '/ics/property/industrial/laichikok888',
        component: () => import('./laichikok888'),
        props: { ics: 'i' },
      },
      {
        name: 'iec2',
        path: '/ics/property/iec2',
        component: () => import('./iec2'),
        props: { ics: 'i' },
      },
      {
        name: 'iec2_i',
        path: '/ics/property/industrial/iec2',
        component: () => import('./iec2'),
        props: { ics: 'i' },
      },
      {
        name: 'iec2_c',
        path: '/ics/property/commercial/iec2',
        component: () => import('./iec2'),
        props: { ics: 'c' },
      },
      {
        name: 'iec3',
        path: '/ics/property/iec3',
        component: () => import('./iec3'),
        props: { ics: 'c' },
      },
      {
        name: 'iec3_i',
        path: '/ics/property/industrial/iec3',
        component: () => import('./iec3'),
        props: { ics: 'i' },
      },
      {
        name: 'iec3_c',
        path: '/ics/property/commercial/iec3',
        component: () => import('./iec3'),
        props: { ics: 'c' },
      },
      {
        name: 'ocs18',
        path: '/ics/property/ocs18',
        component: () => import('./ocs18'),
        props: { ics: 'i' },
      },
      {
        name: 'ocs18_i',
        path: '/ics/property/industrial/ocs18',
        component: () => import('./ocs18'),
        props: { ics: 'i' },
      },
      {
        name: 'ocs18_c',
        path: '/ics/property/commercial/ocs18',
        component: () => import('./ocs18'),
        props: { ics: 'c' },
      },
      {
        name: 'gcc3',
        path: '/ics/property/gcc3',
        component: () => import('./gcc3'),
        props: { ics: 'i' },
      },
      {
        name: 'gcc3_i',
        path: '/ics/property/industrial/gcc3',
        component: () => import('./gcc3'),
        props: { ics: 'i' },
      },
      {
        name: 'gcc3_c',
        path: '/ics/property/commercial/gcc3',
        component: () => import('./gcc3'),
        props: { ics: 'c' },
      },
      {
        name: 'hennessy333',
        path: '/ics/property/hennessy333',
        component: () => import('./hennessy333'),
        props: { ics: 'c' },
      },
      {
        name: 'hennessy333_i',
        path: '/ics/property/industrial/hennessy333',
        component: () => import('./hennessy333'),
        props: { ics: 'i' },
      },
      {
        name: 'hennessy333_c',
        path: '/ics/property/commercial/hennessy333',
        component: () => import('./hennessy333'),
        props: { ics: 'c' },
      },
      {
        name: 'gcc1',
        path: '/ics/property/gcc1',
        component: () => import('./gcc1'),
        props: { ics: 'i' },
      },
      {
        name: 'gcc1_i',
        path: '/ics/property/industrial/gcc1',
        component: () => import('./gcc1'),
        props: { ics: 'i' },
      },
      {
        name: 'gcc1_c',
        path: '/ics/property/commercial/gcc1',
        component: () => import('./gcc1'),
        props: { ics: 'c' },
      },
      {
        name: 'gcc2',
        path: '/ics/property/gcc2',
        component: () => import('./gcc2'),
        props: { ics: 'i' },
      },
      {
        name: 'gcc2_i',
        path: '/ics/property/industrial/gcc2',
        component: () => import('./gcc2'),
        props: { ics: 'i' },
      },
      {
        name: 'gcc2_c',
        path: '/ics/property/commercial/gcc2',
        component: () => import('./gcc2'),
        props: { ics: 'c' },
      },
      {
        name: 'rykadanone',
        path: '/ics/property/rykadanone',
        component: () => import('./rykadanone'),
        props: { ics: 'c' },
      },
      {
        name: 'rykadanone_i',
        path: '/ics/property/industrial/rykadanone',
        component: () => import('./rykadanone'),
        props: { ics: 'i' },
      },
      {
        name: 'rykadanone_c',
        path: '/ics/property/commercial/rykadanone',
        component: () => import('./rykadanone'),
        props: { ics: 'c' },
      },
      {
        name: 'kwuntongroad368',
        path: '/ics/property/kwuntongroad368',
        component: () => import('./kwuntongroad368'),
        props: { ics: 'c' },
      },
      {
        name: 'kwuntongroad368_i',
        path: '/ics/property/industrial/kwuntongroad368',
        component: () => import('./kwuntongroad368'),
        props: { ics: 'i' },
      },
      {
        name: 'kwuntongroad368_c',
        path: '/ics/property/commercial/kwuntongroad368',
        component: () => import('./kwuntongroad368'),
        props: { ics: 'c' },
      },
      {
        name: 'iec1',
        path: '/ics/property/iec1',
        component: () => import('./iec1'),
        props: { ics: 'c' },
      },
      {
        name: 'iec1_i',
        path: '/ics/property/industrial/iec1',
        component: () => import('./iec1'),
        props: { ics: 'i' },
      },
      {
        name: 'iec1_c',
        path: '/ics/property/commercial/iec1',
        component: () => import('./iec1'),
        props: { ics: 'c' },
      },
      {
        name: 'icity',
        path: '/ics/property/icity',
        component: () => import('./icity'),
        props: { ics: 'i' },
      },
      {
        name: 'icity_i',
        path: '/ics/property/industrial/icity',
        component: () => import('./icity'),
        props: { ics: 'i' },
      },
      {
        name: 'icity',
        path: '/ics/property/commercial/icity',
        component: () => import('./icity'),
        props: { ics: 'c' },
      },
      {
        name: 'minisiteDetail',
        path: '/ics/property/minisite/details/:id',
        component: () => import('./details'),
      },
      {
        name: 'minisiteDetailName',
        path: '/ics/property/minisite/details/:id/:buildingName',
        component: () => import('./details'),
      },
      {
        name: 'minisiteHomePage',
        path: '/ics/property/minisite',
        component: () => import('./list'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    Vue.$gmapDefaultResizeBus.$emit('resize');
    next();
  });

  return router;
};
